import script from "./BusinessHallHB.vue?vue&type=script&setup=true&lang=ts"
export * from "./BusinessHallHB.vue?vue&type=script&setup=true&lang=ts"

import "./BusinessHallHB.vue?vue&type=style&index=0&id=2499880a&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/liulv-sound/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2499880a"]])

export default __exports__